<template>

  <v-combobox v-model="user"
                  :label="label || 'User'"
                  :placeholder="placeholder"
                  :items="users"
                  item-text="preferredUsername"
                  return-object
                  :clearable="true"
                  :loading="loading"
                  :disabled="isDisabled"
                  hide-no-data="hide-no-data"
                  :search-input.sync="textInput"></v-combobox>

</template>

<script>

export default {
  name: 'NEWUserSelector',
  props: ['currentUserID', 'label'],
  data () {
    return {
      loading: false,
      users: [],
      user: '',

      textInput: '',

      preventNextSearch: false
    }
  },
  mounted () {
    if (this.currentUserID) {
      this.setCurrentUser()
    }
  },
  methods: {
    handleInput (input) {
      this.loading = false
      this.textInput = input
      setTimeout(() => {
        if (input && (this.textInput === input)) {
          this.loading = true
          this.loadUsers()
        }
      }, 400)
    },
    setCurrentUser () {
      this.loading = true
      this.$store.dispatch('getUser', this.currentUserID)
        .then(resp => {
          this.preventNextSearch = true
          this.users = [resp]
          this.user = resp
          this.loading = false
        })
        .catch(() => {
          console.error('Error loading user')
          this.loading = false
        })
    },
    loadUsers () {
      if (this.preventNextSearch) {
        this.loading = false
        this.preventNextSearch = false
        return
      }

      this.$store.dispatch('searchUsers', {
        preferredUsername: this.textInput
      })
        .then(resp => {
          this.users = resp.items
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },
    clear () {
      this.user = ''
      this.users = []
    }
  },
  computed: {
    isDisabled () {
      return false
    },
    placeholder () {
      return this.isDisabled ? '---' : 'User'
    }
  },
  watch: {
    'textInput' () {
      if (this.textInput) {
        this.handleInput(this.textInput)
      } else {
        this.users = []
      }
    },
    'user' () {
      if (this.user) {
        this.$emit('userSelected', this.user.id || this.user.userID)
      } else {
        this.$emit('userSelected', '')
      }
    },
    'currentUserID' () {
      if (this.currentUserID) {
        this.setCurrentUser()
      }
    }
  }
}

</script>

<style lang="scss" scoped>

  .item-text {
    font-size: 13px;
  }

  .item-text-small {
    font-size: 11px;
  }

</style>



// WEBPACK FOOTER //
// src/components/common/NEWUserSelector.vue